/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var PaymentInvoiceView = require('common/views/PaymentInvoiceView');

var tmplSecCompRegPaymentView = require('../templates/SecCompRegPaymentView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecCompRegPaymentView,

  className: 'sec-compliance-registration-payment-view',

  ui: {
    paymentInvoice: '.payment-invoice'
  },

  regions: {
    paymentInvoice: '@ui.paymentInvoice'
  },

  onBeforeShow: function() {
    var complianceRegistrationId = this.model.get('id');
    this.showChildView(
      'paymentInvoice',
      new PaymentInvoiceView({
        submitButtonTextZeroAmount: 'Submit Compliance Registration',
        model: new Backbone.Model({
          department: 'SECURITIES',
          paymentObjectType: 'COMPLIANCEREG',
          paymentObjectId: complianceRegistrationId,
          items: this.model.get('invoiceItems')
        })
      })
    );
  }
});
